/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessingJobModelDto } from '../../models/processing-job-model-dto';

export interface SuperadminControllerRequeueJob$Params {
  uuid: string;
}

export function superadminControllerRequeueJob(http: HttpClient, rootUrl: string, params: SuperadminControllerRequeueJob$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerRequeueJob.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessingJobModelDto>;
    })
  );
}

superadminControllerRequeueJob.PATH = '/superadmin/jobs/{uuid}/requeue';
